
// SVG Icon: compass-inner-arrows
export default { id: "terriajs-compass-inner-arrows" };
export const id = "terriajs-compass-inner-arrows";
export const name = "compass-inner-arrows";
